import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PANEL_URL = 'https://panel.tenkusports.com';

const LINK = 'text-gray-300 hover:text-brand transition-colors';

const PlayerLinks = ({ t }) => (
  <>
    <li><a href="#features" className={LINK}>{t('header.features')}</a></li>
    <li><a href="#how-it-works" className={LINK}>{t('header.howItWorks')}</a></li>
    <li><a href="#testimonials" className={LINK}>{t('header.testimonials')}</a></li>
    <li><a href="#faq" className={LINK}>{t('header.faq')}</a></li>
    <li><a href={t('downloads.webLink')} className={LINK}>{t('footer.webApp')}</a></li>
    <li><Link to="/venues" className={LINK}>{t('footer.forVenues')}</Link></li>
  </>
);

const VenueLinks = ({ t }) => (
  <>
    <li><a href="#features" className={LINK}>{t('venues.header.features')}</a></li>
    <li><a href="#how-it-works" className={LINK}>{t('venues.header.how')}</a></li>
    <li><a href="#pricing" className={LINK}>{t('venues.header.pricing')}</a></li>
    <li><a href="#contact" className={LINK}>{t('venues.header.contact')}</a></li>
    <li><a href={PANEL_URL} className={LINK}>{t('venues.header.login')}</a></li>
    <li><Link to="/" className={LINK}>{t('footer.forPlayers')}</Link></li>
  </>
);

const Footer = () => {
  const { t } = useTranslation();
  const venues = useLocation().pathname.startsWith('/venues');

  return (
    <footer className="bg-gray-900 border-t border-gray-700 py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-2">
              <img src="/img/brand/isotipo-web.png" alt="" className="h-8" />
              <img src="/img/brand/logotipo-web.png" alt="Tenku" className="h-6" />
            </div>
            <p className="tk-footer-tagline mb-4">{t('footer.tagline')}</p>
            <p className="text-gray-300 mb-6 max-w-md">
              {t(venues ? 'footer.descriptionVenues' : 'footer.description')}
            </p>
            <div className="flex space-x-4 tk-footer-social">
              {/* Facebook */}
              <a href="https://www.facebook.com/people/Sports-Nest-APP/61581173165491/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand transition-colors">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0C5.373 0 0 5.373 0 12c0 5.989 4.388 10.947 10.125 11.854v-8.385H7.078v-3.47h3.047V9.41c0-3.022 1.793-4.687 4.533-4.687 1.312 0 2.686.235 2.686.235v2.953h-1.512c-1.49 0-1.952.926-1.952 1.877v2.247h3.328l-.532 3.47h-2.796V24C19.612 22.947 24 17.989 24 12c0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
              {/* Instagram */}
              <a href="https://www.instagram.com/sportsnest.app/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand transition-colors">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.056 1.97.246 2.427.412a4.92 4.92 0 011.675 1.09 4.92 4.92 0 011.09 1.675c.166.457.356 1.257.412 2.427.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.056 1.17-.246 1.97-.412 2.427a4.902 4.902 0 01-1.09 1.675 4.902 4.902 0 01-1.675 1.09c-.457.166-1.257.356-2.427.412-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.056-1.97-.246-2.427-.412a4.902 4.902 0 01-1.675-1.09 4.902 4.902 0 01-1.09-1.675c-.166-.457-.356-1.257-.412-2.427C2.175 15.747 2.163 15.367 2.163 12s.012-3.584.07-4.85c.056-1.17.246-1.97.412-2.427a4.902 4.902 0 011.09-1.675 4.902 4.902 0 011.675-1.09c.457-.166 1.257-.356 2.427-.412C8.416 2.175 8.796 2.163 12 2.163zm0 1.838c-3.19 0-3.567.012-4.822.07-1.045.048-1.613.218-1.992.362-.495.189-.848.416-1.223.791a2.905 2.905 0 00-.791 1.223c-.144.379-.314.947-.362 1.992-.058 1.255-.07 1.632-.07 4.822s.012 3.567.07 4.822c.048 1.045.218 1.613.362 1.992.189.495.416.848.791 1.223.375.375.728.602 1.223.791.379.144.947.314 1.992.362 1.255.058 1.632.07 4.822.07s3.567-.012 4.822-.07c1.045-.048 1.613-.218 1.992-.362.495-.189.848-.416 1.223-.791.375-.375.602-.728.791-1.223.144-.379.314-.947.362-1.992.058-1.255.07-1.632.07-4.822s-.012-3.567-.07-4.822c-.048-1.045-.218-1.613-.362-1.992a2.905 2.905 0 00-.791-1.223 2.905 2.905 0 00-1.223-.791c-.379-.144-.947-.314-1.992-.362-1.255-.058-1.632-.07-4.822-.07zM12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zm0 10.162a3.999 3.999 0 110-7.998 3.999 3.999 0 010 7.998zm6.406-11.845a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0z"/>
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.product')}</h3>
            <ul className="space-y-2">
              {venues ? <VenueLinks t={t} /> : <PlayerLinks t={t} />}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.legal')}</h3>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-gray-300 hover:text-brand transition-colors">{t('common.privacy')}</Link></li>
              <li><Link to="/terms" className="text-gray-300 hover:text-brand transition-colors">{t('common.terms')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 mt-8 text-center">
          <p className="text-gray-400 text-sm">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;